(function ($) {
  'use strict';

  /**
   * 倒计时组件
   * 倒计时分两种情况：
   * 1.普通倒计时：倒计时结束后，隐藏倒计时组件
   * 2.循环倒计时：倒计时结束后，重新开始倒计时
   */
  class Countdown extends HTMLElement {
    constructor() {
      super();

      const clockIcon = `
          <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <title>reloadtime-outlined</title>
              <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="PC产品页_促销区_V4.1" transform="translate(-1414.000000, -417.000000)" fill="${this.themeColor}" fill-rule="nonzero">
                      <g id="编组-5" transform="translate(1044.000000, 409.000000)">
                          <g id="reloadtime-outlined" transform="translate(370.000000, 8.000000)">
                              <rect id="矩形" opacity="0" x="0" y="0" width="16" height="16"></rect>
                              <path d="M8.3765625,4.265625 L7.625,4.265625 C7.55625,4.265625 7.5,4.321875 7.5,4.390625 L7.5,8.6921875 C7.5,8.7328125 7.51875,8.7703125 7.5515625,8.79375 L10.134375,10.6796875 C10.190625,10.7203125 10.26875,10.709375 10.309375,10.653125 L10.75625,10.04375 C10.7984375,9.9859375 10.7859375,9.9078125 10.7296875,9.86875 L8.5015625,8.2578125 L8.5015625,4.390625 C8.5015625,4.321875 8.4453125,4.265625 8.3765625,4.265625 Z M11.8109375,5.440625 L14.2609375,6.0390625 C14.3390625,6.0578125 14.415625,5.9984375 14.415625,5.91875 L14.428125,3.3953125 C14.428125,3.290625 14.3078125,3.23125 14.2265625,3.296875 L11.7640625,5.2203125 C11.68125,5.2859375 11.709375,5.415625 11.8109375,5.440625 L11.8109375,5.440625 Z M14.43125,10.1453125 L13.5453125,9.840625 C13.48125,9.81875 13.4109375,9.8515625 13.3875,9.915625 C13.3578125,9.9953125 13.3265625,10.0734375 13.29375,10.1515625 C13.015625,10.809375 12.6171875,11.4015625 12.1078125,11.909375 C11.6,12.4171875 11.0078125,12.8171875 10.35,13.0953125 C9.66875,13.3828125 8.9453125,13.5296875 8.1984375,13.5296875 C7.4515625,13.5296875 6.728125,13.384375 6.046875,13.0953125 C5.3890625,12.8171875 4.796875,12.4171875 4.2890625,11.909375 C3.78125,11.4015625 3.3828125,10.809375 3.103125,10.1515625 C2.8171875,9.471875 2.671875,8.746875 2.671875,8 C2.671875,7.253125 2.8171875,6.528125 3.10625,5.846875 C3.384375,5.1890625 3.7828125,4.596875 4.2921875,4.0890625 C4.8,3.58125 5.3921875,3.18125 6.05,2.903125 C6.728125,2.6140625 7.453125,2.46875 8.2,2.46875 C8.946875,2.46875 9.6703125,2.6140625 10.3515625,2.903125 C11.009375,3.18125 11.6015625,3.58125 12.109375,4.0890625 C12.26875,4.25 12.41875,4.4171875 12.55625,4.59375 L13.490625,3.8625 C12.2609375,2.290625 10.346875,1.2796875 8.196875,1.28124819 C4.453125,1.2828125 1.446875,4.3234375 1.484375,8.06875 C1.521875,11.7484375 4.5140625,14.71875 8.2,14.71875 C11.0984375,14.71875 13.5671875,12.88125 14.5078125,10.3078125 C14.53125,10.2421875 14.496875,10.16875 14.43125,10.1453125 L14.43125,10.1453125 Z" id="形状"></path>
                          </g>
                      </g>
                  </g>
              </g>
          </svg>
      `;

      // 样式
      const style = `
          <style>
              :host {
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
              }
              .countdown-contanier {
                  display: inline-block;
                  font-family: var(--host-font-family, 'Montserrat')!important;
                  font-size: 0;
                  text-align: right;
              }
              .clock-icon {
                  display: inline-block;
                  vertical-align: top;
                  margin: 2px 10px;
              }
              .countdown-section {
                  position: relative;
                  font-size: 0;
                  display: flex;
                  flex-direction: column;
                  color:red;
              }
              .countdown-content {
                  display: flex;
                  font-size: 0;
              }
              .countdown-time-box {
                display: flex;
                align-items: center;
              }
              .countdown-time-name {
                  display: inline-block;
                  font-size: 10px;
                  font-weight: 500;
                  line-height: 14px; /* 140% */
                  width: 32px;
                  text-align: center;
                  margin-top: 4px;
              }
              .countdown-postfix {
                  width: 10px;
                  height: 20px;
                  line-height: 20px;
                  display: inline-block;
                  font-size: 14px;
                  text-align: center;
                  color: ${this.themeColor};
              }
              .countdown-time {
                  width: 20px;
                  height: 20px;
                  line-height: 20px;
                  background: ${this.themeColor};
                  border-radius: 2px;
                  text-align: center;
                  font-weight: 500;
                  color: ${this.timeColor};
                  display: inline-block;
                  font-size: 14px;
              }
              ${this.pcStyle}
              @media (max-width: 768px) {
                  .countdown-postfix {
                      width: 10px;
                      height: 18px;
                      line-height: 18px;
                  }
                  
                  .countdown-time {
                      width: 18px;
                      height: 18px;
                      line-height: 18px;
                      font-size: 12px;
                  }
                  .clock-icon {
                      margin: 1px 8px;
                  }
                  ${this.mobileStyle}
              }
          </style>
      `;

      // 模板
      const template = `
          <div class="countdown-contanier">
              ${this.hideIcon === 'true' ? '' : `<i class="clock-icon">${clockIcon}</i>`}
              <div class="countdown-content"></div>
          </div>
      `;

      // 创建一个 shadow root，给指定的元素挂载一个 Shadow DOM，并且返回对 ShadowRoot 的引用
      const shadowRoot = this.attachShadow({ mode: 'open' });
      // 向 shadow root 上挂载样式、模板
      shadowRoot.innerHTML = `${style}${template}`;
      // 根容器
      this.countdownContainer = shadowRoot.querySelector('.countdown-contanier');
    }

    // 获取组件属性
    static get observedAttributes() {
      return [
        'countdown-date',
        'loop-period',
        'font-color',
        'time-color',
        'container',
        'hide-icon',
        'pc-style',
        'mobile-style',
      ];
    }

    // 倒计结束时间
    get countdownDate() {
      return this.getAttribute('countdown-date');
    }

    // 循环周期 单位为：小时
    get loopPeriod() {
      const period = this.getAttribute('loop-period');
      return Number(period || '0');
    }

    // 倒计时时间颜色
    get timeColor() {
      return this.getAttribute('time-color');
    }

    // 主体颜色时钟图标、时间分隔、时间框的颜色
    get themeColor() {
      return this.getAttribute('theme-color');
    }

    // 父容器
    get container() {
      return this.getAttribute('container');
    }

    // 是否隐藏icon
    get hideIcon() {
      return this.getAttribute('hide-icon');
    }

    // 获取pc样式
    get pcStyle() {
      return this.getAttribute('pc-style');
    }

    // 获取手机端样式
    get mobileStyle() {
      return this.getAttribute('mobile-style');
    }

    // 是否保留天数的zero
    get showDayZero() {
      return this.hasAttribute('show-day-zero');
    }
    // 是否显示日期单位名称
    get showTimeName() {
      return this.hasAttribute('show-time-name');
    }

    // 获取倒计时结束回调函数
    get onCountdownEnd() {
      const callbackName = this.getAttribute('on-countdown-end');
      return callbackName ? window[callbackName] : null;
    }

    // 生命周期回调，当自定义元素第一次被连接到文档 DOM 时被调用
    async connectedCallback() {
      this.initData();
    }

    initData() {
      this.finalDate = this.getFinalDate();
      this.start();
    }

    start() {
      if (!this.checkOverdueDate()) return;

      this.display();
      this.inrerval = setInterval(() => this.display(), 1000);
    }

    display() {
      this.render(this.getRemainingTime());
    }

    // 获取倒计时结束时间
    getFinalDate() {
      // countdownDate为北京时间，需要获取北京时间对应的时间戳
      let startTime = this.countdownDate ? Number(this.countdownDate) : new Date().getTime();
      if (this.loopPeriod) {
        const now = new Date();
        while (true) {
          if (startTime > now) {
            break;
          } else {
            startTime += this.loopPeriod * 3600 * 1000;
          }
        }
      }
      return new Date(startTime);
    }

    checkOverdueDate() {
      if (this.getTotal() < 0) {
        if (!this.loopPeriod) {
          if (this.inrerval) clearInterval(this.inrerval);
          if (this.container) {
            document.querySelector(`#${this.container}`).classList.add('d-none-important');
          }
          // 调用倒计时结束回调函数
          if (this.onCountdownEnd) {
            this.onCountdownEnd();
          }
          return false;
        }
        // 更新倒计时结束时间
        this.finalDate = this.getFinalDate();
        return true;
      } else {
        return true;
      }
    }

    getTotal() {
      return Date.parse(this.finalDate) - Date.parse(new Date());
    }

    getRemainingTime() {
      if (!this.checkOverdueDate()) {
        return false;
      }

      const total = this.getTotal();
      const seconds = Math.floor((total / 1000) % 60);
      const minutes = Math.floor((total / 1000 / 60) % 60);
      const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
      const days = Math.floor(total / (1000 * 60 * 60 * 24));

      return {
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
      };
    }

    render(time) {
      let html = '';
      let store_name = window?.makeblock?.shop?.store_name;
      let days,hours,minutes,seconds;
      if(store_name == 'de-xtool'){
          days = 'Tag';
          hours = 'Std.';
          minutes = 'Min.';
          seconds = 'Sek.';
      }else if(store_name == 'fr-xtool'){
          days = 'Jours';
          hours = 'Heures';
          minutes = 'Minutes';
          seconds = 'Secondes';
      }else if(store_name == 'jp-xtool'){
          days = '日';
          hours = '時間';
          minutes = '分';
          seconds = '秒';
      }else{
          days = 'Days';
          hours = 'Hours';
          minutes = 'Mins';
          seconds = 'Secs';
      }
      html += this.buildSectionHTML(time.days, ':', this.showDayZero,this.showTimeName,days);
      html += this.buildSectionHTML(time.hours, ':', true,this.showTimeName,hours);
      html += this.buildSectionHTML(time.minutes, ':', true,this.showTimeName,minutes);
      html += this.buildSectionHTML(time.seconds, '', true,this.showTimeName,seconds);
      
      this.countdownContainer.querySelector('.countdown-content').innerHTML = html;
  }

    buildSectionHTML(time, postfix, showZero, showTimeName, timeName) {
      if (!time && !showZero) return '';
      let timeToString = time.toString();
      if (timeToString.length < 2) timeToString = `0${time}`;

      return `<span class="countdown-section">
                  <span class="countdown-time-box">
                    <span class="countdown-time">${timeToString}</span>
                    ${postfix ? `<span class="countdown-postfix">${postfix}</span>` : ''}
                  </span>
                  ${showTimeName ? `<span class="countdown-time-name">${timeName}</span>` : ''}
              </span>`;
    }

    disconnectedCallback() {
      if (this.inrerval) clearInterval(this.inrerval);
    }
  }

  theme.AssetsLoader.onPageLoaded(function () {
    customElements.define('top-banner-countdown', Countdown);
  });
})(jQueryTheme);